exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".colorpicker{display:flex;flex-wrap:wrap;align-items:center;margin-bottom:20px}.colorpicker__color{width:60px;margin-left:15px}.colorpicker__percent{width:45px;margin-left:15px}.colorpicker span{margin-left:15px;width:21px;height:21px;border-radius:50%;border:2px solid #fff}", ""]);

// exports
